import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import { ListViewSettingModel } from '@fi-app/components/items-list/list-view-setting.model';
import { ItemListContainerBase } from '@fi-app/core/item-list-container-base';
import { FiDisplayType } from '@fi-shared/types/display-type';
import { ILightWeightTag } from '@fi-app/shared/fi-tag2/fi-tag2';
import { FiItemsListHelperService } from '@fi-app/shared/fi-items-list/fi-items-list-helper.service';
import { IMediaBankFile } from '@fi-app/shared/media-bank/media-bank';

@Component({
    selector: 'fi-media-bank-list-container',
    template: `
        <!-- <fi-media-bank-list-view [listData]="ListData" [mediaListViewSettings]="mediaListViewSettings">
        </fi-media-bank-list-view> -->

        @let tagIds = getTagIds();
        <fi-media-bank-new-list
            [isItemActionsShown]="false"
            [tagsPositionType]="mediaListViewSettings.PositionType"
            [displayType]="displayType"
            [hasCheckedColumn]="allowSelection"
            [allowMultiSelect]="false"
            (selectionChanged)="onSelectionChanged($event)"
            [isTagsSectionShown]="showAllTagsList || !!tagIds?.length"
            [limitedTagIds]="tagIds"
        />
    `,
    styleUrls: ['./media-bank-list-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MediaBankListContainerComponent extends ItemListContainerBase {
    mediaListViewSettings: ListViewSettingModel;
    showAllTagsList: boolean;
    allowSelection: boolean;
    private itemsListHelperService = inject(FiItemsListHelperService);

    // ListData: ListData<MediaBankFileModel>;
    protected readonly displayType = FiDisplayType.List;

    protected getTagIds(): number[] | undefined {
        if (this.showAllTagsList) {
            return undefined;
        }
        return this.mediaListViewSettings.ListViewTags.map((tag) => tag.Id);
    }

    protected onSelectionChanged($event: IMediaBankFile[]): void {
        this.itemsListHelperService.triggerExtendedSearchSelectionChanged($event);
    }
}
